import {
  Bot,
  Briefcase,
  Earth,
  Factory,
  Globe,
  GraduationCap,
  Handshake,
  Landmark,
  Lightbulb,
  Mic,
  Presentation,
  TrendingUp,
  Users,
  Leaf,
} from "lucide-react";

const ICONS = {
  bot: Bot,
  factory: Factory,
  trending: TrendingUp,
  graduation: GraduationCap,
  landmark: Landmark,
  presentation: Presentation,
  briefcase: Briefcase,
  globe: Globe,
  lightbulb: Lightbulb,
  users: Users,
  handshake: Handshake,
  mic: Mic,
  earth: Earth,
};

export const BrandIcon = ({ name, className = "h-5 w-5" }) => {
  const Cmp = ICONS[(name || "").trim().toLowerCase()] || Leaf;
  return <Cmp className={className} strokeWidth={1.6} aria-hidden="true" />;
};
